import { FC, useEffect } from "react";
import { Helmet } from "react-helmet";
import { fetchAsync } from "../../services/ApiHandler";
import { PromptHintSet } from "../../model/PromptHintSet";

export const AccountClosedPage: FC = () => {
  return <>
    <Helmet>
      <title>Drop AIアカウント解約完了</title>
      <meta name="description" content="Drop AIアカウント解約完了" />
    </Helmet>
      <div className="mt-4 text-base sm:text-lg font-bold">Drop AIアカウント解約が完了しました。<br/>ご利用いただきありがとうございます。</div>
  </>;
}